// Evidence-based clinical recommendations (curated, offline).
// Fonti: linee guida di società scientifiche e revisioni indicizzate su PubMed.
export const CONDITIONS = [
  {
    value: "sovrappeso_obesita",
    label: "Sovrappeso / Obesità",
    reco: [
      "Deficit calorico moderato di 500–750 kcal/die (calo 0,5–0,75 kg/settimana).",
      "Apporto proteico 1,2–1,6 g/kg per preservare la massa magra durante il dimagrimento.",
      "Pattern mediterraneo, alta densità nutrizionale e buon potere saziante.",
    ],
    escludere: ["Bevande zuccherate e succhi", "Snack industriali e dolciumi", "Fritti e fast food", "Alcolici"],
    limitare: ["Zuccheri semplici e farine raffinate", "Salumi e carni processate", "Formaggi molto grassi", "Condimenti grassi in eccesso"],
    preferire: ["Verdura in abbondanza a ogni pasto", "Proteine magre (pesce, pollame, legumi, uova)", "Cereali integrali", "Olio EVO a crudo con moderazione"],
    consigli: ["Attività aerobica ≥150 min/settimana + rinforzo muscolare 2 volte/settimana.", "Pasti regolari, evitare digiuni prolungati che favoriscono le abbuffate.", "Buona idratazione e sonno adeguato (7–8 h)."],
    refs: ["AHA/ACC/TOS Obesity Guideline 2013 (PMID: 24239920)", "WHO Obesity 2024"],
  },
  {
    value: "insulino_resistenza",
    label: "Insulino-resistenza / Prediabete",
    reco: [
      "Ridurre il carico glicemico: carboidrati a basso indice glicemico e integrali.",
      "Distribuire i carboidrati nei pasti e abbinarli sempre a fibra/proteine/grassi.",
      "Calo ponderale del 5–10% migliora nettamente la sensibilità insulinica.",
    ],
    escludere: ["Zuccheri aggiunti e bevande zuccherate", "Dolci e prodotti da forno raffinati", "Succhi di frutta"],
    limitare: ["Pane bianco, riso bianco, patate", "Frutta molto zuccherina in grandi quantità", "Alcol"],
    preferire: ["Legumi e cereali integrali", "Verdura non amidacea", "Proteine magre e grassi buoni (EVO, frutta secca)", "Frutta a basso IG (frutti di bosco, mela)"],
    consigli: ["Attività fisica dopo i pasti aiuta il controllo glicemico.", "Perdere peso e ridurre il grasso viscerale sono prioritari.", "Preferire cotture semplici; evitare lunghe cotture della pasta (al dente)."],
    refs: ["ADA Standards of Care 2024 (PMID: 38078574)", "Diabetes Prevention Program (PMID: 11832527)"],
  },
  {
    value: "diabete2",
    label: "Diabete Mellito Tipo 2",
    reco: [
      "Carboidrati a basso indice glicemico distribuiti nei pasti.",
      "Fibra ≥25–35 g/die per il controllo glicemico post-prandiale.",
      "Grassi mono/polinsaturi al posto dei saturi.",
    ],
    escludere: ["Bevande e alimenti zuccherati", "Dolci, miele, sciroppi", "Succhi di frutta"],
    limitare: ["Cereali raffinati e patate", "Frutta ad alto IG (uva, banana matura)", "Alcolici"],
    preferire: ["Verdura, legumi, cereali integrali", "Pesce azzurro e proteine magre", "Frutta secca non salata", "Olio EVO"],
    consigli: ["Coordinare alimentazione, terapia e attività fisica con il diabetologo.", "Autocontrollo glicemico secondo indicazione medica.", "Attività fisica regolare aerobica + resistenza."],
    refs: ["ADA Standards of Care 2024 (PMID: 38078574)", "Reynolds A. et al., Lancet 2019 (PMID: 30638909)"],
  },
  {
    value: "sindrome_metabolica",
    label: "Sindrome Metabolica",
    reco: [
      "Dieta mediterranea come pattern di riferimento cardiometabolico.",
      "Ridurre carico glicemico e zuccheri raffinati.",
      "Ridurre la circonferenza vita con calo ponderale.",
    ],
    escludere: ["Zuccheri e bevande zuccherate", "Grassi trans e fritti", "Alcolici"],
    limitare: ["Sale (<5 g/die)", "Carboidrati raffinati", "Carni processate"],
    preferire: ["Verdura, frutta, legumi", "Cereali integrali", "Pesce, olio EVO, frutta secca"],
    consigli: ["Attività aerobica regolare associata all'intervento dietetico.", "Gestione integrata di pressione, glicemia e lipidi."],
    refs: ["Estruch R. et al., PREDIMED NEJM 2018 (PMID: 29897866)"],
  },
  {
    value: "pcos",
    label: "PCOS (Ovaio Policistico)",
    reco: [
      "In presenza di insulino-resistenza: dieta a basso carico glicemico.",
      "Calo ponderale del 5–10% migliora ciclo, ovulazione e parametri metabolici.",
      "Adeguato apporto proteico e di fibre.",
    ],
    escludere: ["Zuccheri e bevande zuccherate", "Dolci e prodotti raffinati"],
    limitare: ["Carboidrati ad alto IG", "Latticini in eccesso (se indicato)", "Alcol"],
    preferire: ["Alimenti a basso IG e integrali", "Proteine magre, pesce azzurro (omega-3)", "Verdura e legumi", "Grassi buoni (EVO, frutta secca)"],
    consigli: ["Attività fisica regolare per migliorare la sensibilità insulinica.", "Valutare con lo specialista eventuale inositolo/metformina."],
    refs: ["International PCOS Guideline 2023 (Teede et al.)", "ESHRE/ASRM PCOS"],
  },
  {
    value: "nafld",
    label: "Steatosi Epatica (NAFLD/MASLD)",
    reco: [
      "Calo ponderale 7–10% riduce il grasso epatico e l'infiammazione.",
      "Dieta mediterranea, riduzione di zuccheri semplici (soprattutto fruttosio industriale).",
      "Eliminazione dell'alcol.",
    ],
    escludere: ["Alcol", "Bevande zuccherate e sciroppo di fruttosio", "Dolci e snack industriali"],
    limitare: ["Zuccheri semplici", "Carni rosse e processate", "Fritti e grassi saturi"],
    preferire: ["Verdura, legumi, cereali integrali", "Pesce azzurro (omega-3)", "Olio EVO, frutta secca", "Caffè non zuccherato (effetto protettivo)"],
    consigli: ["Attività fisica aerobica + resistenza riduce il grasso epatico anche senza grande calo di peso.", "Controllo di glicemia e lipidi."],
    refs: ["EASL-EASD-EASO CPG NAFLD 2016 (PMID: 27062661)", "AASLD 2023"],
  },
  {
    value: "ipertensione",
    label: "Ipertensione Arteriosa",
    reco: [
      "Pattern DASH ricco di frutta, verdura e latticini magri.",
      "Sodio < 2 g/die (≈5 g di sale).",
      "Aumentare potassio da alimenti (salvo controindicazioni renali).",
    ],
    escludere: ["Salumi e cibi in salamoia", "Dadi e brodi pronti", "Snack salati", "Liquirizia"],
    limitare: ["Sale aggiunto", "Formaggi stagionati", "Alcol", "Caffeina in eccesso"],
    preferire: ["Frutta e verdura fresca", "Legumi e cereali integrali", "Pesce", "Erbe e spezie al posto del sale"],
    consigli: ["Attività fisica aerobica regolare.", "Calo ponderale se sovrappeso.", "Monitoraggio domiciliare della pressione."],
    refs: ["Appel LJ. et al., DASH NEJM (PMID: 9099655)", "ESC/ESH 2023 (PMID: 37345492)"],
  },
  {
    value: "ipercolesterolemia",
    label: "Ipercolesterolemia",
    reco: [
      "Sostituire grassi saturi con mono/polinsaturi.",
      "10–25 g/die di fibra solubile e 2 g/die di fitosteroli.",
      "Eliminare i grassi trans.",
    ],
    escludere: ["Grassi trans (margarine idrogenate, prodotti industriali)", "Fritti", "Insaccati grassi"],
    limitare: ["Burro, strutto, formaggi grassi", "Carni rosse", "Dolci da forno"],
    preferire: ["Avena e orzo (beta-glucani)", "Legumi", "Olio EVO, frutta secca", "Pesce azzurro"],
    consigli: ["Attività fisica regolare.", "Calo ponderale se necessario.", "Aderenza alla terapia ipolipemizzante se prescritta."],
    refs: ["ESC/EAS Dyslipidaemias 2019 (PMID: 31504418)"],
  },
  {
    value: "ipertrigliceridemia",
    label: "Ipertrigliceridemia",
    reco: [
      "Ridurre drasticamente zuccheri semplici e alcol.",
      "Aumentare omega-3 (EPA/DHA).",
      "Calo ponderale e controllo glicemico.",
    ],
    escludere: ["Alcol", "Bevande zuccherate e dolci", "Sciroppi e miele"],
    limitare: ["Carboidrati raffinati", "Frutta molto zuccherina", "Grassi saturi"],
    preferire: ["Pesce azzurro (omega-3)", "Verdura e legumi", "Cereali integrali", "Olio EVO"],
    consigli: ["Attività fisica aerobica regolare.", "Perdita di peso in caso di sovrappeso."],
    refs: ["ESC/EAS Dyslipidaemias 2019 (PMID: 31504418)"],
  },
  {
    value: "iperuricemia_gotta",
    label: "Iperuricemia / Gotta",
    reco: [
      "Ridurre gli alimenti ad alto contenuto di purine.",
      "Eliminare alcol (soprattutto birra) e bevande fruttosate.",
      "Buona idratazione (≥2 L/die) e calo ponderale graduale.",
    ],
    escludere: ["Alcol (birra e superalcolici)", "Frattaglie (fegato, rene)", "Bevande zuccherate/fruttosio", "Estratti di carne e selvaggina"],
    limitare: ["Carni rosse", "Pesce ad alto contenuto di purine (acciughe, sardine, cozze)", "Legumi in fase acuta"],
    preferire: ["Latticini magri", "Verdura", "Cereali integrali", "Ciliegie e frutti di bosco", "Acqua"],
    consigli: ["Evitare digiuni e diete chetogeniche in fase acuta.", "Calo di peso lento e costante."],
    refs: ["ACR Gout Management Guideline 2020 (PMID: 32390306)"],
  },
  {
    value: "ipotiroidismo",
    label: "Ipotiroidismo",
    reco: [
      "Adeguato apporto di iodio e selenio, senza eccessi.",
      "Levotiroxina a digiuno, distanziata da caffè, soia, calcio e ferro.",
      "Deficit calorico moderato considerando la possibile riduzione del TDEE.",
    ],
    escludere: [],
    limitare: ["Soia in prossimità del farmaco", "Verdure crucifere crude in grandi quantità (goitrogene)", "Cibi ultra-processati"],
    preferire: ["Pesce e fonti di iodio (con moderazione)", "Verdura e frutta", "Cereali integrali, proteine magre"],
    consigli: ["Assumere la terapia con costanza e distanza dai pasti.", "Attività fisica per contrastare la tendenza al sovrappeso."],
    refs: ["ATA Hypothyroidism Guideline (PMID: 25266247)"],
  },
  {
    value: "reflusso",
    label: "Reflusso Gastroesofageo (GERD)",
    reco: [
      "Pasti piccoli e frequenti, evitare abbuffate serali.",
      "Non coricarsi nelle 2–3 ore dopo il pasto.",
      "Calo ponderale se sovrappeso.",
    ],
    escludere: ["Fritti e cibi molto grassi", "Cioccolato", "Menta", "Bevande gassate e alcol"],
    limitare: ["Caffè e tè", "Pomodoro e agrumi (se sintomatici)", "Cibi piccanti", "Fumo"],
    preferire: ["Verdura cotta", "Cereali integrali", "Proteine magre", "Cotture semplici (vapore, forno)"],
    consigli: ["Rialzare la testiera del letto.", "Evitare indumenti stretti in vita."],
    refs: ["ACG GERD Guideline 2022 (PMID: 34807007)"],
  },
  {
    value: "gastrite",
    label: "Gastrite / Dispepsia",
    reco: [
      "Pasti regolari, piccoli e ben masticati.",
      "Evitare irritanti della mucosa gastrica.",
      "Se positività Helicobacter pylori, seguire terapia eradicante prescritta.",
    ],
    escludere: ["Alcol", "Cibi molto piccanti", "Fritti"],
    limitare: ["Caffè e bevande contenenti caffeina", "Cibi molto grassi", "Bevande gassate", "Fumo"],
    preferire: ["Verdura cotta", "Cereali integrali ben tollerati", "Proteine magre", "Cotture leggere"],
    consigli: ["Evitare FANS a stomaco vuoto.", "Gestire lo stress."],
    refs: ["ACG Dyspepsia Guideline 2017"],
  },
  {
    value: "stipsi",
    label: "Stipsi Cronica",
    reco: [
      "Aumentare gradualmente la fibra fino a 25–30 g/die.",
      "Idratazione adeguata (1,5–2 L/die).",
      "Attività fisica regolare.",
    ],
    escludere: [],
    limitare: ["Alimenti raffinati e poveri di fibra", "Eccesso di formaggi", "Fast food"],
    preferire: ["Verdura, frutta con buccia", "Legumi", "Cereali integrali", "Frutta secca, semi di lino, kiwi, prugne"],
    consigli: ["Regolarità nella routine intestinale.", "Aumentare la fibra insieme all'acqua per evitare gonfiore."],
    refs: ["ACG Chronic Constipation Guideline", "Cochrane Dietary fibre"],
  },
  {
    value: "ibs",
    label: "Sindrome Intestino Irritabile (IBS)",
    reco: [
      "Dieta low-FODMAP a fasi (eliminazione, reintroduzione, personalizzazione).",
      "Pasti regolari e adeguata idratazione.",
      "Preferire fibra solubile.",
    ],
    escludere: ["Dolcificanti polioli (sorbitolo, xilitolo)", "Bevande gassate", "Alcol"],
    limitare: ["Cipolla, aglio, legumi (fase eliminazione)", "Latticini con lattosio", "Frumento in eccesso", "Caffeina"],
    preferire: ["Riso, avena, patate", "Verdura low-FODMAP (zucchine, carote, spinaci)", "Proteine magre", "Frutta low-FODMAP (fragole, kiwi, agrumi)"],
    consigli: ["Percorso guidato da nutrizionista per le fasi FODMAP.", "Gestione dello stress (asse intestino-cervello)."],
    refs: ["Halmos EP. et al., Gastroenterology 2014 (PMID: 24076059)"],
  },
  {
    value: "irc",
    label: "Insufficienza Renale Cronica",
    reco: [
      "Apporto proteico controllato (0,6–0,8 g/kg) negli stadi avanzati non in dialisi.",
      "Controllo di sodio, potassio e fosforo secondo indicazione.",
      "Bilancio idrico personalizzato.",
    ],
    escludere: ["Sale aggiunto e cibi in salamoia", "Integratori senza indicazione medica"],
    limitare: ["Alimenti ricchi di potassio (banane, patate, pomodoro) se iperkaliemia", "Alimenti ricchi di fosforo (formaggi, cola, insaccati)", "Proteine in eccesso"],
    preferire: ["Verdura a basso potassio (dopo ammollo/bollitura)", "Cereali", "Proteine ad alto valore biologico in quota controllata"],
    consigli: ["Gestione dietetica sempre concordata con nefrologo e dietista.", "Tecniche di cottura per ridurre il potassio (doppia bollitura)."],
    refs: ["KDIGO 2020 / KDOQI Nutrition 2020 (PMID: 32829751)"],
  },
  {
    value: "menopausa",
    label: "Menopausa (gestione del peso)",
    reco: [
      "Adeguato apporto proteico (1,0–1,2 g/kg) e di calcio/vitamina D.",
      "Deficit calorico moderato per contrastare l'aumento del grasso viscerale.",
      "Dieta mediterranea.",
    ],
    escludere: ["Bevande zuccherate", "Alcol in eccesso"],
    limitare: ["Zuccheri semplici", "Sale (per pressione e ritenzione)", "Grassi saturi"],
    preferire: ["Proteine magre e latticini/fonti di calcio", "Verdura e frutta", "Cereali integrali, legumi", "Pesce azzurro (omega-3)"],
    consigli: ["Allenamento di forza per preservare massa muscolare e ossa.", "Esposizione solare/vitamina D secondo indicazione."],
    refs: ["EMAS/NAMS Menopause Nutrition", "Mediterranean diet reviews"],
  },
  {
    value: "ritenzione",
    label: "Ritenzione Idrica / Edema",
    reco: [
      "Ridurre il sodio alimentare.",
      "Buona idratazione e movimento.",
      "Aumentare potassio da frutta e verdura (salvo controindicazioni).",
    ],
    escludere: ["Salumi e cibi in salamoia", "Snack salati", "Dadi e brodi pronti"],
    limitare: ["Sale aggiunto", "Cibi ultra-processati", "Alcol"],
    preferire: ["Frutta e verdura ricche di potassio", "Cibi freschi non processati", "Erbe e spezie al posto del sale"],
    consigli: ["Attività fisica regolare e movimento delle gambe.", "Escludere cause mediche di edema con il medico."],
    refs: ["WHO Sodium intake guideline 2012"],
  },
  {
    value: "sport_ipertrofia",
    label: "Sport / Ipertrofia Muscolare",
    reco: [
      "Proteine 1,6–2,2 g/kg distribuite in 3–5 pasti da 0,3–0,4 g/kg.",
      "Surplus calorico contenuto (+10–15%) in fase di massa.",
      "Carboidrati adeguati peri-workout per performance e recupero.",
    ],
    escludere: [],
    limitare: ["Alcol", "Cibi ultra-processati", "Zuccheri semplici fuori dal peri-workout"],
    preferire: ["Fonti proteiche complete (uova, carne magra, pesce, latticini)", "Cereali e tuberi per i carboidrati", "Frutta e verdura", "Grassi buoni"],
    consigli: ["Programmazione dell'allenamento progressivo.", "Sonno e recupero adeguati."],
    refs: ["Morton RW. et al., BJSM 2018 (PMID: 28698222)", "ISSN Position Stand (PMID: 28642676)"],
  },
];
